import { inject, injectable } from 'tsyringe';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentUserRepository } from 'application/repositorySchemas/IAgentUserRepository';

// UseCase
export interface IAgentUserLogout {
    readonly agentUserToken: IAgentUserTokenRepository;
    readonly agentUser: IAgentUserRepository;
    execute(): Promise<void>;
}

// Interactor
@injectable()
export class AgentUserLogout implements IAgentUserLogout {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentUserRepository')
        public readonly agentUser: IAgentUserRepository,
    ) {}

    public async execute() {
        const token = this.agentUserToken.get();
        if (token === null) {
            return;
        }
        await this.agentUser.logout();
        this.agentUserToken.remove();
    }
}
